import React, { Component } from "react";
import { Tooltip, Spin, Button, message } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";
import GridTable from "@/components/display/table/gridTableCore";
import { qryTicketNumByArea } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import ExportJsonExcel from 'js-export-excel';
import { QuestionCircleFilled } from "@ant-design/icons";
class TicketBoardAreaSub extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      fromType:1,
      btnType:1,
      tableConfig: null,
      tableConfig1: null,
      dataSource1:[],
      dataSource: [],
      addDisabled:false,
      loading: false,
    };
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig();
    this.initTableConfig1();
    this.handleGetDataSource();
  }

   /**
   * 父组件参数修改后，子组件调用方法
   */
   componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.params) !== JSON.stringify(this.props.params)) {
      this.handleGetDataSource(nextProps.params);
    }
  }

   /** */
   initTableConfig1 = () => {
    this.setState({
      tableConfig1: {
        tableKey: "chargeSuccessTop1011StationTable",
        tableColumns: [
          {
            name: "大区",
            key: "areaName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "城市类型",
            key: "cityTypeName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "城市名称",
            key: "cityName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单类型",
            key: "ticketTypeName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单总数",
            key: "newNum",
            colType: "textCol",
            align: "center",
          },
          // {
          //   name: "设备类型",
          //   key: "type",
          //   colType: "textCol",
          //   align: "center",
          //   render: (text) => {
          //     if (text == null)
          //     {
          //       return '';
          //     } else if (parseInt(text) == 0)
          //     {
          //       return '交流电';
          //     } else if (parseInt(text) == 1)
          //     {
          //       return '直流电';
          //     } else if (parseInt(text) == 2)
          //     {
          //       return '交直流';
          //     }
          //   },
          // },
          {
            name: "完成工单数",
            key: "finishNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "超时工单数",
            key: "overNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单总时长",
            key: "handleNumTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均响应时长",
            key: "evResTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均处理时长",
            key: "excuteTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均验收时长",
            key: "yanTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单完成率",
            key: "finishTimeRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
          {
            name: "工单及时率",
            key: "jiTimeRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state.dataSource1,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /** */
  initTableConfig = () => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessTop10StationTable",
        tableColumns: [
          {
            name: "工单类型",
            key: "ticketTypeName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单总数",
            key: "newNum",
            colType: "textCol",
            align: "center",
          },
          // {
          //   name: "设备类型",
          //   key: "type",
          //   colType: "textCol",
          //   align: "center",
          //   render: (text) => {
          //     if (text == null)
          //     {
          //       return '';
          //     } else if (parseInt(text) == 0)
          //     {
          //       return '交流电';
          //     } else if (parseInt(text) == 1)
          //     {
          //       return '直流电';
          //     } else if (parseInt(text) == 2)
          //     {
          //       return '交直流';
          //     }
          //   },
          // },
          {
            name: "完成工单数",
            key: "finishNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "超时工单数",
            key: "overNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单总时长",
            key: "handleNumTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均响应时长",
            key: "evResTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均处理时长",
            key: "excuteTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "平均验收时长",
            key: "yanTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单完成率",
            key: "finishTimeRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
          {
            name: "工单及时率",
            key: "jiTimeRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "详情",
                handler: (res) => {
                  this.setState(
                    {
                      btnType:2,
                      fromType:2,
                      levelType:res.ticketType
                    },
                    () => {
                      this.handleGetDataSource();
                    },
                  );
                },
              },
            ],
          },
          // {
          //   name: "成功率",
          //   key: "successRate",
          //   colType: "textCol",
          //   align: "center",
          //   render: (text) => {
          //     return `${text}%`;
          //   },
          // },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state.dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };
  
  handleClick = () => {
    if (this.state.fromType == 1) {
    var data = [];
    if (this.state.dataSource != null && this.state.dataSource.length > 0)
    {
      data = this.state.dataSource;
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['工单类型'] = data[i]['ticketTypeName'];
        obj['工单总数'] = data[i]['newNum'];
        obj['完成工单数'] = data[i]['finishNum'];
        obj['超时工单数'] = data[i]['overNum'];
        obj['工单总时长'] = data[i]['handleNumTime'];
        obj['平均响应时长'] = data[i]['evResTime'];
        obj['平均处理时长'] = data[i]['excuteTime'];
        obj['平均验收时长'] = data[i]['yanTime'];
        obj['工单完成率'] = data[i]['finishTimeRate'] + '%';
        obj['工单及时率'] = data[i]['jiTimeRate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['工单类型', '工单总数', '完成工单数', '超时工单数', '工单总时长', '平均响应时长', '平均处理时长',
  '平均验收时长', '工单完成率', '工单及时率'];
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";
    option.fileName = '工单分类完成率'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  } else {
    var data = [];
    if (this.state.dataSource1 != null && this.state.dataSource1.length > 0)
    {
      data = this.state.dataSource1;
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['大区'] = data[i]['areaName'];
        obj['城市类型'] = data[i]['cityTypeName'];
        obj['城市名称'] = data[i]['cityName'];
        obj['工单类型'] = data[i]['ticketTypeName'];
        obj['工单总数'] = data[i]['newNum'];
        obj['完成工单数'] = data[i]['finishNum'];
        obj['超时工单数'] = data[i]['overNum'];
        obj['工单总时长'] = data[i]['handleNumTime'];
        obj['平均响应时长'] = data[i]['evResTime'];
        obj['平均处理时长'] = data[i]['excuteTime'];
        obj['平均验收时长'] = data[i]['yanTime'];
        obj['工单完成率'] = data[i]['finishTimeRate'];
        obj['工单及时率'] = data[i]['jiTimeRate'];
        dataTable.push(obj);
      }
    }
    var header = ['大区', '城市类型', '城市名称', '工单类型', '工单总数', '完成工单数', '超时工单数', '工单总时长', '平均响应时长', '平均处理时长',
  '平均验收时长', '工单完成率', '工单及时率'];
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";
    option.fileName = '各地市工单完成率'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  }
  };


  backTotal = () => {
    
    this.setState(
      {
        btnType:1,
        fromType:1,
      },
      () => {
        this.handleGetDataSource();
      },
    );
  };
  // 获取数据源
  handleGetDataSource = (param) => {
    if (!param || param == null)
    {
      param = this.props.params;
    }
    if ((!param.cityIds || param.cityIds == null) && (!param.provinceIds || param.provinceIds == null))
    {
      if (this.state.btnType == 1)
      {
        this.setState(
          {
            dataSource: [],
          },
          () => {
            this.initTableConfig();
          },
        );
      } else {
        this.setState(
          {
            dataSource1: [],
          },
          () => {
            this.initTableConfig1();
          },
        );
      }
      return;
    }
    this.setState({
      loading: true,
    });
    fetchHandler(qryTicketNumByArea, {
      cityIds: param.cityIds,
      provinceIds: param.provinceIds,
      month: param.month,
      type:this.state.fromType,
      levelType:this.state.fromType == 1 ? null : this.state.levelType,
    }).then((res) => {
      if (res.data) {
        // res.data = [{"stubId":"99008888","stubGroupId":null,"stubGroupName":null,"totalOrder":7,"successOrder":4,"failureOrder":3,"successRate":"57.14","serial":1},{"stubId":"99008877","stubGroupId":null,"stubGroupName":null,"totalOrder":5,"successOrder":4,"failureOrder":1,"successRate":"80.00","serial":2},{"stubId":"99008833","stubGroupId":null,"stubGroupName":null,"totalOrder":3,"successOrder":3,"failureOrder":0,"successRate":"100.00","serial":3},{"stubId":"1029358001","stubGroupId":null,"stubGroupName":null,"totalOrder":2,"successOrder":2,"failureOrder":0,"successRate":"100.00","serial":4},{"stubId":"2021090101","stubGroupId":null,"stubGroupName":null,"totalOrder":1,"successOrder":1,"failureOrder":0,"successRate":"100.00","serial":5},{"stubId":"3204090601","stubGroupId":null,"stubGroupName":null,"totalOrder":1,"successOrder":1,"failureOrder":0,"successRate":"100.00","serial":6}];
        res.data.forEach((area) => {
          if (area.ticketType == 11)
          {
            area.ticketTypeName = '故障工单';
          } else if (area.ticketType == 89)
          {
            area.ticketTypeName = '充电桩故障工单';
          } else if (area.ticketType == 90)
          {
            area.ticketTypeName = '地锁故障工单';
          } else if (area.ticketType == 15)
          {
            area.ticketTypeName = '通用工单';
          } else if (area.ticketType == 12)
          {
            area.ticketTypeName = '巡检工单';
          } else if (area.ticketType == 13)
          {
            area.ticketTypeName = '调试工单';
          } else if (area.ticketType == 14)
          {
            area.ticketTypeName = '验收工单';
          } else if (area.ticketType == 91)
          {
            area.ticketTypeName = '保养工单';
          } else if (area.ticketType == 88)
          {
            area.ticketTypeName = '清洁工单';
          }
          if (!area.cityType || area.cityType == null)
          {
            area.cityTypeName = '';
          } else if (area.cityType == 1)
          {
            area.cityTypeName = 'A类';
          } else if (area.cityType == 2)
          {
            area.cityTypeName = 'B类';
          } else if (area.cityType == 3)
          {
            area.cityTypeName = 'C类';
          } 
          area.handleNumTime = area.handleNum == 0 ? 0 : (parseInt(area.handleNum) / 3600).toFixed(2);
          area.evResTime = area.newNum == 0 ? 0 : (area.responseTime / 3600 / area.newNum).toFixed(2);
          area.yanTime = area.newNum == 0 ? 0 : (area.lookTime / 3600 / area.newNum).toFixed(2);
          area.excuteTime = area.newNum == 0 ? 0 : (area.handleNum / 3600 / area.newNum).toFixed(2);
          area.finishTimeRate = area.newNum == 0 ? 0 : (area.finishNum / area.newNum * 100).toFixed(2);
          area.jiTimeRate = area.newNum == 0 ? 0 : ((area.newNum - area.overNum) / area.newNum * 100).toFixed(2);
        });
        if (this.state.btnType == 1)
        {
          this.setState(
            {
              dataSource: res.data,
            },
            () => {
              this.initTableConfig();
            },
          );
        } else {
          this.setState(
            {
              dataSource1: res.data,
            },
            () => {
              this.initTableConfig1();
            },
          );
        }
      }
      this.setState({
        loading: false,
      });
    });
  };

  render() {
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";

    return (
      <Spin spinning={this.state.loading}>
        <div className='section'>
          <div className='title-box'>
            <div style={{    display: 'flex',alignItems: 'center'}}>
            <div className='title'>
              {this.state.btnType === 1
                ? `工单分类完成率`
                : "各地市工单完成率"}
                <Tooltip
                        title={() => <span style={{ color: "#000" }}>一级列表是各工单类型的统计数据，点操作详情是看指定工单类型各城市的统计数据</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
            </div>
            <Button
              onClick={this.handleClick}
              type="primary"
              disabled={this.state.addDisabled}
              style={{ margin: "5px" }}>
              导出
            </Button>

            {this.state.btnType === 2 ? (
           <Button
           onClick={this.backTotal}
           type="primary"
           disabled={this.state.addDisabled}
           style={{ margin: "5px" }}>
           返回
         </Button>
          ) : null}

            
              </div>
          </div>
          
          {this.state.btnType === 1 ? (
           <ScGridTable config={this.state.tableConfig} />
          ) : null}
          {this.state.btnType === 2 ? (
           <GridTable config={this.state.tableConfig1} />
          ) : null}
        </div>
      </Spin>
    );
  }
}

export default TicketBoardAreaSub;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/ticketBoardAreaSub.js